import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-field__value" }

import { FieldWrapper as KFieldWrapper } from '@progress/kendo-vue-form';
import { Error as KError, Hint as KHint } from '@progress/kendo-vue-labels';
import FormLabel from '@/components/common/label/FormLabel.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormTemplate',
  props: {
    disabled: { type: Boolean, default: false },
    isValid: { type: Boolean, default: true },
    isRequired: { type: Boolean, default: false },
    label: { default: '' },
    labelId: { default: undefined },
    labelBehavior: { default: undefined },
    inputId: { default: undefined },
    validationMessage: { default: undefined },
    hintMessage: { default: undefined },
    width: { default: '230px' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KFieldWrapper), { class: "form-field" }, {
    default: _withCtx(() => [
      _createVNode(FormLabel, {
        id: __props.labelId,
        "label-text": __props.label,
        "input-id": __props.inputId,
        "is-required": __props.isRequired,
        "is-disabled": __props.disabled,
        size: 'medium',
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, {
        "label-end": _withCtx(() => [
          _renderSlot(_ctx.$slots, "label-end")
        ]),
        _: 3
      }, 8, ["id", "label-text", "input-id", "is-required", "is-disabled"]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        (!__props.isValid && __props.validationMessage)
          ? (_openBlock(), _createBlock(_unref(KError), {
              key: 0,
              class: "form-field__errors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.validationMessage), 1)
              ]),
              _: 1
            }))
          : (__props.hintMessage)
            ? (_openBlock(), _createBlock(_unref(KHint), { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.hintMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "notification")
      ])
    ]),
    _: 3
  }))
}
}

})